import React from 'react';
import { LOGO_URL, NAV } from '../data/content';

export default function Footer() {
  return (
    <footer className="bg-[#0B1230] text-white pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-10">
          <div>
            <div className="inline-flex bg-white rounded-xl px-3 py-2"><img src={LOGO_URL} alt="ExcellenC" className="h-9"/></div>
            <p className="mt-6 text-[13.5px] text-white/70 max-w-md leading-relaxed">
              ExcellenC's AI-Powered Data Science Professional Program — live, mentor-led training with real-time industry projects, Machine Learning, Generative & Agentic AI, and structured placement assistance.
            </p>
            <a href="https://wa.me/919182384041" target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 bg-[#E63329] hover:bg-[#c41d13] text-white text-[13px] font-semibold px-5 py-2.5 rounded-full transition-colors">Talk to Admissions</a>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.25em] uppercase text-white/60 font-semibold">Program</div>
            <ul className="mt-5 space-y-3">
              {NAV.map(n => (
                <li key={n.href}><a href={n.href} className="text-[13.5px] text-white/80 hover:text-white transition-colors">{n.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.25em] uppercase text-white/60 font-semibold">Contact</div>
            <ul className="mt-5 space-y-3 text-[13.5px] text-white/80">
              <li>Hyderabad · Bengaluru</li>
              <li>hello@excellenc.in</li>
              <li>+91 91823 84041</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap justify-between gap-4 text-[12px] text-white/55">
          <div>© {new Date().getFullYear()} ExcellenC. Towards Growth.</div>
          <div>AI-Powered Data Science Professional Program</div>
        </div>
      </div>
    </footer>
  );
}
